import {get } from "../../pwa/ajax";
import * as BucketTools from "./bucket";
import * as Utilities from "./utilities";
import { rankingDeCategoria } from "../../../Settings/global/acumulado.json";


const sitioId = window.config.Sitio.Id;
const urlRankingSitio = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiRankingSitioUrl;
const urlRankingCategoria = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiRankingCategoriaUrl;
const bucket = window.config.Statics.BucketUrl;
const bucketClubLn = window.config.Statics.BucketClubLnUrl.replace("dp-","");
const urlPromoContentLab = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiAcumuladoTipoTagUrl;
const urlPromoClubLn = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiPromoClubLnUrl;
const cantidadNotasPromoContentLab = 10; //TODO: ver de obtenerla de la configuracion
const tagTipoContentLab = 10; //TODO: ver de obtenerla de la configuracion
const urlEconomiaCotizacionDivisas = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiEconomiaCotizacionDivisasUrl;
//devuelve un numero random entre el rango establecido
const getRandomInteger = (min, max) => {
    let _min = Math.ceil(min);
    let _max = Math.floor(max + 1);
    return Math.floor(Math.random() * (_max - _min)) + _min;
}

const renderRanking = (data) => {
    const container = document.getElementById("ranking");
    if (!container) return;
    let rankingCategoria = document.querySelector("main[data-Acu-TagRelaCatId]");
    let rankingDescripcion = "leídas ahora";
    if (rankingCategoria != null && parseInt(rankingCategoria.getAttribute("data-Acu-TagRelaCatId")) > 0) {
        let categoria = rankingDeCategoria.find(x => x.id == parseInt(rankingCategoria.getAttribute("data-Acu-TagRelaCatId")));
        rankingDescripcion = categoria != null ? "leídas de " + categoria.descripcion : rankingDescripcion;
    }

    let ranking = `<div class="techo floatFix"><h4>Más <b>${rankingDescripcion}</b></h4></div>`;
    const notas = data.items.slice(0, 5);
    let toi = 201;
    ranking += "<ol>";
    for (let i = 0; i < notas.length; i++) {
        const nota = notas[i];

        let imageHtml = "";
        if (nota.imagenes instanceof Array && nota.imagenes.length > 0 && nota.imagenes[0].src != null && nota.imagenes[0].src != "") {
            imageHtml = `<a class="figure"  href="/${nota.url}">                                                                
                                 <img src="${BucketTools.urlBucketBalance(bucket, nota.imagenes[0].src, "", "102")}"/>
                        </a>`;
        } else {
            imageHtml = `<a class="figure"  href="/${nota.url}">      
                        </a>`;
        }

        let toiPos = "toi".concat(toi.toString());
        ranking += `<li>
                        <article class="nota floatFix" data-id="${nota.id}" data-notaid="${nota.id}" data-source="ranking" data-pos="${toiPos}">`;
        ranking += imageHtml;
        ranking += `<h2>
                        <a href="/${nota.url}">
                            ${nota.titulo}
                        </a>
                    </h2>
                </article>
             </li>`;
        toi++;
    }
    ranking += "</ol>";
    container.innerHTML = ranking;
}

const renderNotasHeader = (data) => {
    const acumulado = document.querySelector("div[data-notaHeader]");
    //console.log(document.referrer)
    if (acumulado !== null && (document.referrer === "" || document.referrer.split('/')[2].indexOf(location.hostname) === -1)) {
        const notas = data.items.slice(0, 4);
        let toi = 251;
        let html = `<section class="listado sugeridas floatFix" id="bloque-1" data-is-block="true" data-block-name="n_cinturon-header" data-diagramacion-id="0"><div class="floatFix">`;
        for (let nota of notas) {
            let imageHtml = (nota.imagenes instanceof Array && nota.imagenes.length > 0 && nota.imagenes[0].src != null && nota.imagenes[0].src != "") ?
                             `<a class="figure"  href="/${nota.url}">                                   
                                    <img src="${BucketTools.urlBucketBalance(bucket, nota.imagenes[0].src, "69")}">
                              </a>` 
                            : `<a class="figure"  href="/${nota.url}"></a>`;
            let toiPos = "toi".concat(toi.toString());
            html += `<article title="" class="nota foto floatFix"  data-id="${nota.id}" data-notaid="${nota.id}" data-source="ranking" data-pos="${toiPos}">
                ${imageHtml}
                <h2>
                    <a href="/${nota.url}">
                        ${nota.titulo}
                    </a>
                </h2>
                </article>`;
            toi++;
        }
        html += `</div></section>`;
        acumulado.innerHTML = html;
    }
}

const renderHeaderAndRanking = (data) => {
    renderNotasHeader(data);
    renderRanking(data);
}

export const getRanking = () => {
    if (!!document.getElementById("ranking")) {
        //todo: desacoplar esto.
        let rankyngByCategoria = document.querySelector("main[data-Acu-TagRelaCatId]");
        let rankyngByCategoriaId = "0";
        if (rankyngByCategoria) {
            rankyngByCategoriaId = rankyngByCategoria.getAttribute("data-Acu-TagRelaCatId");
        }

        let urlBy = urlRankingSitio;
        let getById = sitioId;

        if (rankyngByCategoriaId != "0" || rankingDeCategoria.find(x => x.id == rankyngByCategoriaId)) {
            urlBy = urlRankingCategoria;
            getById = rankyngByCategoriaId;
        }

        get(urlBy + getById)
            .then(rs => renderHeaderAndRanking(JSON.parse(rs)))
            .catch(errorUrl);
    }
}

const errorUrl = () => {
    get(urlRankingSitio + sitioId)
        .then(rs => JSON.parse(rs))
        .then(renderHeaderAndRanking);
}

const renderPromoContentLab = (data) => {
    const container = document.getElementById("promoContenLab");
    if (!container) return;
    const notas = data.items;

    if (notas == null) {
        container.parentNode.removeChild(container);
        return;
    }
        

    const cantidadNotas = notas.length;
    if (cantidadNotas == 0) {
        container.parentNode.removeChild(container);
        return;
    }
        

    //getRandom
    let indexRandom = getRandomInteger(0, cantidadNotas - 1);

    let nota = notas[indexRandom];
    let notaUrl = "";
    if (nota.sitioId !== 1) {
      notaUrl = Utilities.getUrlSitios(nota.sitioId) + nota.url;
    } else {
        notaUrl = nota.url;
    }

    let promoContentLabHtml = '<h3> CONTENT LAB PARA </h3>';
    const urlTag = Utilities.FormatearUrl(nota.tagDestacado.valor) + "-t" + nota.tagDestacado.id;
    const taghtml = "<a href=\"/" + urlTag + "\">" + nota.tagDestacado.valor + "</a>";
    let imageHTML = "";
    let imageUrl = "";

    if (nota.imagenes instanceof Array && nota.imagenes.length > 0 && nota.imagenes[0].src != null && nota.imagenes[0].src != "") {
        imageUrl = BucketTools.urlBucketBalance(bucket, nota.imagenes[0].src, "200", "300");
        imageHTML = `<img src="${imageUrl}"/>`;
    }
    let classFigure = `<a href="${notaUrl}" class="figure">     
                        ${imageHTML}                            
                      </a>`;
    promoContentLabHtml += taghtml;
    promoContentLabHtml += classFigure;
    promoContentLabHtml += `<h2><a href="${notaUrl}">${nota.titulo}</a></h2>`;

    container.innerHTML = promoContentLabHtml;
}

const renderPromoClubLn = (data) => {
    const container = document.getElementById("promoClubLn");
    if (container) {
        const notas = data;

        if (notas == null) {
            container.parentNode.removeChild(container);
            return;
        }
            

        const cantidadNotas = notas.length;
        if (cantidadNotas == 0) {
            container.parentNode.removeChild(container);
            return;
        }
            

        //getRandom
        let indexRandom = Utilities.getRandomInteger(0, cantidadNotas - 1);

        let nota = notas[indexRandom];
        
        let promoPromoClubLnHtml = `<h3>BENEFICIOS</h3><a href="https://club.lanacion.com.ar/" target="_blank">Club LA NACION</a>
                                    <div class="floatFix">`;

        const benefit = nota.benefits[0];
        const establecimientoImg = nota.imagenDestacar;

        let imageHTML = "";
        let imageUrlDesktop = "";
        let imageUrlTablet = "";

        if (establecimientoImg != undefined && establecimientoImg != 0 ) {
            var  objDestacado = nota.images.find(img => img.id == establecimientoImg);
            if (objDestacado != undefined) {
                imageUrlDesktop = BucketTools.urlBucketClubLn(bucketClubLn, objDestacado.id, "220", "300", objDestacado.extension);
                imageUrlTablet = BucketTools.urlBucketClubLn(bucketClubLn, objDestacado.id, "100", "137", objDestacado.extension);
                imageHTML = `<picture>
                                <source media="(min-width: 768px)" srcset="${imageUrlDesktop}">
                                <img src="${imageUrlTablet}" alt="Flowers">
                        </picture>`; 
            }      
        }

        if (imageHTML == "" && benefit.images != null && benefit.images.length > 0) {
            imageUrlDesktop = BucketTools.urlBucketClubLn(bucketClubLn, benefit.images[0].id, "220", "300", benefit.images[0].extension);
            imageUrlTablet = BucketTools.urlBucketClubLn(bucketClubLn, benefit.images[0].id, "100", "137", benefit.images[0].extension);
            imageHTML = `<picture>
                                <source media="(min-width: 768px)" srcset="${imageUrlDesktop}">
                                <img src="${imageUrlTablet}" alt="Flowers">
                        </picture>`;             
        }

        let classFigure = `<a href="${nota.link}" class="figure" target="_blank">     
                            ${imageHTML}                
                           </a>`;

        promoPromoClubLnHtml += classFigure;
        promoPromoClubLnHtml += `<a href="${nota.link}" class="beneficio">
                                    <span>${benefit.benefitTypeName}</span>
                                    <h2>${nota.name}</h2>
                                </a>
                                </div>`;

        container.innerHTML = promoPromoClubLnHtml;

    }
}

const renderCotizacionDivisasDolar = (data) => {
    const container = document.getElementById("cotizacionDivisasDolar");
    if (container) {
        const cotizaciones = data;

        if (cotizaciones == null)
            return;

        if (cotizaciones.length == 0)
            return;

        const cotizacionDolar = cotizaciones.filter(d => d.papel == "DLRBILL")[0];

        const compraValorEntero = cotizacionDolar.compra.split(",")[0];
        const compraValorCentavos = cotizacionDolar.compra.split(",")[1];
        const ventaValorEntero = cotizacionDolar.venta.split(",")[0];
        const ventaValorCentavos = cotizacionDolar.venta.split(",")[1];

        let cotizacionDolarHtml = `<div class="techo floatFix">
                                        <h4>Cotización </br> <b>Dólar Oficial</b></h4>
                                        <a href="https://www.hausler.com.ar/la/?utm_source=lanacion&utm_medium=bmobile&utm_campaign=lnabril&l=LA&fuente=Mi4gTWFya2V0aW5nIERpZ2l0YWw=&subfuente=Mi43IExhIE5hY2nDs24=" target="_blank"></a>
                                    </div>
                                    <div class="cotiza">
                                        <div>
                                            <h5>Compra</h5>
                                            <span>$${compraValorEntero},</span>
                                            <span>${compraValorCentavos}</span>
                                        </div>
                                        <div>
                                            <h5>Venta</h5>
                                            <span>$${ventaValorEntero},</span>
                                            <span>${ventaValorCentavos}</span>
                                        </div>
                                        <div class="auspiciante">
                                            Provisto por
                                            <a href="http://www.invertironline.com/" target="_blank"><figure></figure></a>
                                        </div>
                                    </div>`;

        container.innerHTML = cotizacionDolarHtml;

    }
}

export const getPromoClubLn = () => {
    if (document.getElementById("promoClubLn")) {
        get(urlPromoClubLn)
            .then(rs => JSON.parse(rs))
            .then(renderPromoClubLn);
    }
}

export const getPromoContentLab = () => {
    if (document.getElementById("promoContenLab")) {
        get(`${urlPromoContentLab + tagTipoContentLab}?c=${cantidadNotasPromoContentLab}&h=1&s=${sitioId}`)
            .then(rs => JSON.parse(rs))
            .then(renderPromoContentLab);
    }  
}

export const getCotizacionDivisas = () => {
    if (document.getElementById("cotizacionDivisasDolar")) {
        get(urlEconomiaCotizacionDivisas)
            .then(rs => JSON.parse(rs))
            .then(renderCotizacionDivisasDolar);
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/tercera.js